import React from "react";

export class TagsTableViewViewModel {
    constructor(props, state) {
        this.tagsDisabledClass = function () {
            let tagsDisabledClass = '';
            if (props.loading) {
                tagsDisabledClass = ' is-loading-tags';
            } else if (state.isModalOpen && state.modalType === 'delete') {
                tagsDisabledClass = 'tags-delete-background';
            }
            return tagsDisabledClass
        }

        this.message = function () {
            const loadingDiv = <div style={{textAlign: "center"}}>Loading...</div>;
            const loadingMsg = props.loading ? loadingDiv : 'No Configurations Available!';
            const message = props.errorMsg ? props.errorMsg : loadingMsg;
            return message
        }
    }
}
